// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pp9N","title":"styles_title__YiNE1"};